<template>
  <applicant-list :filters="filters"/>
</template>
<script>
  import ApplicantList from 'src/views/admin/talent/ApplicantList'

  export default {
    components: {
      ApplicantList
    },
    computed: {
      candidate () {
        return this.$store.state.candidate.currentCandidate || {}
      },
      filters() {
        return [
          {
            key: 'with',
            value: 'job'
          },
          {
            key: 'match[email]',
            value: this.candidate.email
          },
          {
            key: 'sort',
            value: '+created_at'
          }
        ]
      }
    }
  }
</script>
<style>
</style>
